module.exports = __webpack_public_path__ + "static/media/28.61a75c65.jpg";